import iconStateLoading from '../assets/icons/state-loading.svg';
import iconStateWaiting from '../assets/icons/state-waiting.svg';
import iconStatePlaying from '../assets/icons/state-waiting-playing.svg';
import iconStatePaused from '../assets/icons/state-paused.svg';
import iconStateError from '../assets/icons/state-error.svg';
import iconStateAdPlaying from '../assets/icons/state-adplaying.svg';
import iconStateAdLoading from '../assets/icons/state-adloading.svg';
import Component from './component';
import { get } from '../../utils/dot-notation';
import en from '../languages/en.json';

const stateIcons = {
  loading: iconStateLoading,
  playing: iconStatePlaying,
  paused: iconStatePaused,
  adplaying: iconStateAdPlaying,
  adloading: iconStateAdLoading,
  waiting: iconStateWaiting,
  error: iconStateError,
  empty: iconStatePaused,
  idle: iconStatePaused,
  notready: iconStatePaused
};

const stateTooltips = {
  loading: 'player.loading',
  playing: 'player.pause',
  paused: 'player.play',
  adplaying: 'player.pause',
  adloading: 'player.loading',
  waiting: 'player.waiting',
  error: 'player.error',
  empty: 'player.play',
  idle: 'player.play',
  notready: 'player.play'
};

/**
 * Custom button component that changes it's icon and label depending on the state of the player
 */
export default class StateButton extends Component {
  constructor (props) {
    super(props);
    this.handleEvent = this.handleEvent.bind(this);
  }

  getDefaultProps () {
    return {
      class: '',
      iconClass: '',
      locale: en,
      paused: true,
      state: 'empty',
      player: null,
      tooltip: get(en, stateTooltips.empty, ''),
      label: en.player.play,
      icon: stateIcons.empty || iconStatePaused,
      onclick: function () {}
    };
  }

  /**
   * Update the state of the button
   *
   * @param {Object} state
   */
  setState (state) {
    if (state.state !== undefined) {
      this.props.state = state.state;
    }

    if (state.paused !== undefined) {
      this.props.paused = state.paused;
    }

    this.props.tooltip = get(this.props.locale, stateTooltips[this.props.state], '');
    this.props.label = this.props.locale.player[this.props.paused ? 'play' : 'pause'];
    this.props.icon = stateIcons[this.props.state] || iconStatePaused;

    this.update();
  }

  /**
   * Handle player and ui events
   *
   * @param {Object} event
   */
  handleEvent (event) {
    if (this.props.player && event.type === 'click') {
      this.props.player.togglePlay();
      return;
    }

    if (event.type === 'click') {
      this.props.onclick(event);
      return;
    }

    if (!this.props.player) return;

    if (this.props.player.getState() === 'adplaying') {
      this.setState({
        state: (event.type === 'adloading') ? 'adloading' : 'adplaying',
        paused: this.props.player.isPaused()
      });
    } else {
      this.setState({
        state: event.currentState,
        paused: this.props.player.isPaused()
      });
    }
  }

  /**
   * Attach the component to a DOM element
   *
   * @param {DOMElement} element
   */
  attach (element) {
    super.attach(element);

    this.$element.addEventListener('click', this);

    if (this.props.player) {
      this.props.player.on('state', this.handleEvent);
      this.props.player.on('adplaylistload', this.handleEvent);
      this.props.player.on('adplaying', this.handleEvent);
    }
  }

  /**
   * Detach the component from a DOM element
   */
  detach () {
    if (this.isAttached()) {
      this.$element.removeEventListener('click', this);

      if (this.props.player) {
        this.props.player.off('state', this.handleEvent);
        this.props.player.off('adplaylistload', this.handleEvent);
        this.props.player.off('adplaying', this.handleEvent);
      }
    }

    super.detach();
  }

  /**
   * Update the component ui
   */
  update () {
    if (!this.isAttached()) return;

    this.$element.setAttribute('title', this.props.tooltip);
    this.$('.iono-button-label').textContent = this.props.label;
    this.$('.iono-button-icon').innerHTML = this.props.icon;
  }

  /**
   * Destroy the component
   */
  destroy () {
    this.detach();
  }

  render () {
    return `
      <button class="${this.props.class} iono-icon-button iono-padding-0" title="${this.props.tooltip}">
        <span class="iono-icon iono-button-icon ${this.props.iconClass}" aria-hidden="true">${this.props.icon}</span>
        <span class="iono-button-label iono-sr-only">${this.props.label}</span>
      </button>
    `;
  }
}
